import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';

interface AuthHeaderProps {
  showLoginButton?: boolean;
  showSignupButton?: boolean;
}

export const AuthHeader: FunctionComponent<AuthHeaderProps> = ({
  showLoginButton = false,
  showSignupButton = false
}) => {
  return (
    <header className="auth-header">
      <div className="auth-header-content">
        <div className="auth-header-logo">
          <a href="https://payearned.com/" target="_blank" rel="noopener noreferrer">
            <img src="/img/Auth_header_logo.png" alt="PAYearned" />
          </a>
        </div>
        <div className="auth-header-right">
          {showLoginButton && (
            <>
              <span className="auth-header-text">Already have an account?</span>
              <Link to="/" className="auth-header-button">
                <Icon name="user circle outline" />
                
                Login
              </Link>
            </>
          )}
          {showSignupButton && (
            <>
              <span className="auth-header-text">Don't have an account?</span>
              <Link to="/signup" className="auth-header-button">
                Sign up FREE
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default AuthHeader;
